var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CCard',[_c('CCardBody',{staticClass:"text-center"},[_c('CImg',{staticClass:"img-fluid",attrs:{"src":"/01.jpeg","width":"80%"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }